const resources = {
  "en": {
    "tasksToConfirm": {
      "title": "Manual payout queue",
      "description": "Confirm synced expenses, reconcile manual payouts, and keep your queue clean.",
      "noticeTitle": "Pending tasks stay in the queue until you act",
      "noticeSummary": "Overdue tasks remain pending, fall out of forecasts after their due date, and post on the scheduled date once you confirm them.",
      "bulkCancelTitle": "Old tasks can pile up if you step away for a while",
      "bulkScopeAuto": "Cancel auto tasks only",
      "bulkScopeAll": "Cancel every pending task",
      "bulkCancelSummaryAuto": "{{count}} auto-generated tasks are still waiting here. You can clear them without touching your manual tasks.",
      "bulkCancelSummaryAll": "{{count}} pending tasks are still waiting here. You can clear the queue if you want to start fresh.",
      "bulkCancelAction": "Clear queue",
      "bulkCancelConfirmTitle": "Clear pending tasks?",
      "bulkCancelConfirmAuto": "Cancel {{count}} auto-generated tasks and keep your manual tasks untouched.",
      "bulkCancelConfirmAll": "Cancel {{count}} pending tasks from the queue. This does not create transactions and does not touch past history.",
      "bulkCancelConfirmOk": "Yes, clear them",
      "bulkCancelConfirmCancel": "Keep queue",
      "bulkCancelSuccess": "✅ Cleared {{count}} tasks from the queue",
      "bulkCancelFailed": "Failed to clear the queue",
      "cardTitle": "Tasks to confirm",
      "summaryTitle": "Pending queue totals",
      "summarySubtitle": "{{count}} tasks are waiting across the whole queue.",
      "summaryTaskCount": "{{count}} tasks",
      "summaryExpenses": "Expenses",
      "summaryIncomes": "Incomes",
      "summaryNet": "Net if confirmed",
      "summaryUnavailable": "{{count}} tasks are missing amount data and are not included in totals.",
      "commitment": {
        "summaryTitle": "Commitment risk",
        "summary": {
          "missed": "{{count}} missed",
          "critical": "{{count}} critical",
          "highPriority": "{{count}} high priority",
          "dueToday": "{{count}} due today"
        },
        "tags": {
          "missed": "Missed promise",
          "dueToday": "Due today",
          "critical": "Critical",
          "highPriority": "High priority",
          "mustDo": "Must do",
          "keptLate": "Kept late"
        },
        "notes": {
          "missed": "You promised this for {{date}}. It is {{count}} days late.",
          "dueToday": "You promised this for today.",
          "importantGoal": "Marked important because it is tied to a goal.",
          "importantDebt": "Marked important because it is tied to a debt or payment.",
          "importantGeneric": "Marked important by the system."
        }
      },
      "repaymentPlan": {
        "autoTag": "Auto · repayment plan",
        "fallbackLabel": "repayment plan",
        "basedOn": "Based on {{label}}.",
        "editHint": "Confirm or cancel this installment here. Change the plan to adjust future installments."
      },
      "accountSummary": {
        "title": "Account/card impact",
        "subtitle": "Shows which selected account or card will carry the pending payments.",
        "availableNow": "Available now",
        "net": "Pending net",
        "after": "After confirmation",
        "readyTag": "Enough",
        "insufficientTag": "Short",
        "currencyMismatchTag": "Currency mismatch",
        "accountNotFoundTag": "Account missing",
        "unknownTag": "Needs balance",
        "unknownAmount": "Unknown",
        "unavailable": "{{count}} tasks are missing account or balance data and are not included in account/card totals."
      },
      "accountReadiness": {
        "readyTag": "Account ready",
        "insufficientTag": "Account risk",
        "unknownTag": "Needs account data",
        "missingAccountTag": "No account",
        "currencyMismatchTag": "Currency mismatch",
        "expenseBody": "{{account}} has {{before}} available now and would have {{after}} after this payment.",
        "incomeBody": "{{account}} has {{before}} available now and would have {{after}} after this income.",
        "missingAccount": "Choose an account before confirming so the forecast can show the right card or wallet.",
        "accountNotLoaded": "This task points to an account that is not loaded in the current account list.",
        "missingAmount": "{{account}} is selected, but this task has no usable amount yet.",
        "currencyMismatch": "{{account}} is {{accountCurrency}}, but this task is {{taskCurrency}}."
      },
      "addManualTask": "Add manual task",
      "emptyTitle": "No tasks waiting for confirmation",
      "emptyDescription": "Manual payouts and bank sync items will land here. Start with a manual task to learn the flow.",
      "emptyCta": "Add manual task",
      "loadFailed": "❌ Failed to load tasks",
      "accountsLoadFailed": "❌ Failed to load accounts",
      "confirmed": "✅ Task confirmed",
      "cancelled": "🛑 Task cancelled",
      "actionFailed": "Failed to update task",
      "created": "✅ Task created",
      "createFailed": "Failed to create task",
      "createModalTitle": "Add manual task",
      "createModalDescription": "Set a description and amount to queue a payout for reconciliation.",
      "createSubmit": "Create task",
      "updated": "✅ Task updated",
      "updateFailed": "Failed to update task",
      "editAction": "Edit",
      "editModalTitle": "Edit task before confirmation",
      "editModalDescription": "Update the amount, date, account, or category before this task creates a transaction.",
      "editSubmit": "Save changes",
      "sourceRequired": "Description is required",
      "sourcePlaceholder": "Description",
      "categoryLabel": "Category",
      "categoryRequired": "Category is required",
      "categoryPlaceholder": "Choose the best category",
      "amountRequired": "Amount is required",
      "accountRequired": "Account is required",
      "dueDateLabel": "Due date",
      "dueDateRequired": "Due date is required",
      "dueDatePlaceholder": "Select due date",
      "legendTitle": "Status legend",
      "legendTasks": "Task types",
      "legendTaskStates": "Task states",
      "scheduledFor": "Scheduled for {{date}}",
      "unscheduled": "Unscheduled",
      "upcomingHint": "Future task. Confirm it only when you want this scheduled payout to move forward.",
      "scheduleState": {
        "overdue": "Overdue",
        "today": "Today",
        "upcoming": "Upcoming",
        "unscheduled": "No date"
      },
      "createdAt": "Created {{date}}",
      "confirmAction": "Confirm",
      "cancelAction": "Cancel",
      "cancelConfirmTitle": "Cancel this task?",
      "cancelConfirmDescription": "This will remove it from the queue. You can recreate it later if needed.",
      "cancelConfirmOk": "Yes, cancel it",
      "cancelConfirmCancel": "Keep task",
      "accountModalTitle": "Select account",
      "accountModalHint": "We will reuse your last account selection. Update it if this payout should land somewhere else.",
      "accountPlaceholder": "Account",
      "untitled": "Untitled"
    }
  },
  "uk": {
    "tasksToConfirm": {
      "title": "Черга ручних виплат",
      "description": "Підтверджуйте синхронізовані витрати, звіряйте ручні виплати й тримайте чергу охайною.",
      "noticeTitle": "Задачі залишаються в черзі, доки ви не виконаєте дію",
      "noticeSummary": "Прострочені задачі лишаються в очікуванні, після дедлайну зникають із прогнозів і проводяться за запланованою датою лише після підтвердження.",
      "bulkCancelTitle": "Якщо ви давно не відкривали застосунок, старі задачі могли накопичитися",
      "bulkScopeAuto": "Скасувати лише авто-задачі",
      "bulkScopeAll": "Скасувати всі задачі в черзі",
      "bulkCancelSummaryAuto": "У черзі ще {{count}} автостворених задач. Їх можна прибрати, не чіпаючи ручні задачі.",
      "bulkCancelSummaryAll": "У черзі ще {{count}} задач на підтвердження. За потреби можна очистити все й почати з чистої черги.",
      "bulkCancelAction": "Очистити чергу",
      "bulkCancelConfirmTitle": "Очистити чергу задач?",
      "bulkCancelConfirmAuto": "Скасувати {{count}} автостворених задач і залишити ручні задачі без змін.",
      "bulkCancelConfirmAll": "Скасувати {{count}} задач у черзі. Це не створює транзакції й не змінює вашу минулу історію.",
      "bulkCancelConfirmOk": "Так, очистити",
      "bulkCancelConfirmCancel": "Залишити як є",
      "bulkCancelSuccess": "✅ Із черги прибрано {{count}} задач",
      "bulkCancelFailed": "Не вдалося очистити чергу",
      "cardTitle": "Задачі на підтвердження",
      "summaryTitle": "Підсумок черги",
      "summarySubtitle": "У всій черзі очікує {{count}} задач.",
      "summaryTaskCount": "{{count}} задач",
      "summaryExpenses": "Витрати",
      "summaryIncomes": "Доходи",
      "summaryNet": "Нетто після підтвердження",
      "summaryUnavailable": "{{count}} задач без суми не включено в підсумки.",
      "commitment": {
        "summaryTitle": "Ризик обіцянок",
        "summary": {
          "missed": "{{count}} прострочено",
          "critical": "{{count}} критично",
          "highPriority": "{{count}} пріоритетно",
          "dueToday": "{{count}} сьогодні"
        },
        "tags": {
          "missed": "Обіцянку пропущено",
          "dueToday": "Сьогодні",
          "critical": "Критично",
          "highPriority": "Високий пріоритет",
          "mustDo": "Треба зробити",
          "keptLate": "Виконано із запізненням"
        },
        "notes": {
          "missed": "Ви обіцяли зробити це {{date}}. Запізнення: {{count}} днів.",
          "dueToday": "Ви обіцяли зробити це сьогодні.",
          "importantGoal": "Позначено важливим, бо це повʼязано з ціллю.",
          "importantDebt": "Позначено важливим, бо це повʼязано з боргом або платежем.",
          "importantGeneric": "Позначено важливим системою."
        }
      },
      "repaymentPlan": {
        "autoTag": "Авто · план платежів",
        "fallbackLabel": "план платежів",
        "basedOn": "Створено на основі: {{label}}.",
        "editHint": "Цей платіж можна підтвердити або скасувати тут. Майбутні платежі змінюються через сам план."
      },
      "accountSummary": {
        "title": "Вплив на рахунки й картки",
        "subtitle": "Показує, який рахунок або картка прийме очікувані оплати.",
        "availableNow": "Доступно зараз",
        "net": "Нетто в черзі",
        "after": "Після підтвердження",
        "readyTag": "Вистачає",
        "insufficientTag": "Не вистачає",
        "currencyMismatchTag": "Валюта не збігається",
        "accountNotFoundTag": "Рахунок відсутній",
        "unknownTag": "Потрібен баланс",
        "unknownAmount": "Невідомо",
        "unavailable": "{{count}} задач без рахунку або балансу не включено в підсумки по рахунках/картках."
      },
      "accountReadiness": {
        "readyTag": "Рахунок готовий",
        "insufficientTag": "Ризик по рахунку",
        "unknownTag": "Потрібні дані рахунку",
        "missingAccountTag": "Без рахунку",
        "currencyMismatchTag": "Валюта не збігається",
        "expenseBody": "На {{account}} зараз доступно {{before}}, після цієї оплати буде {{after}}.",
        "incomeBody": "На {{account}} зараз доступно {{before}}, після цього доходу буде {{after}}.",
        "missingAccount": "Оберіть рахунок перед підтвердженням, щоб прогноз показував правильну картку або гаманець.",
        "accountNotLoaded": "Ця задача посилається на рахунок, якого немає в поточному списку рахунків.",
        "missingAmount": "{{account}} обрано, але в задачі ще немає коректної суми.",
        "currencyMismatch": "{{account}} має валюту {{accountCurrency}}, а задача має {{taskCurrency}}."
      },
      "addManualTask": "Додати ручне завдання",
      "emptyTitle": "Немає задач на підтвердження",
      "emptyDescription": "Ручні виплати та синхронізація банку потраплятимуть сюди. Почніть із ручного завдання, щоб протестувати процес.",
      "emptyCta": "Додати ручне завдання",
      "loadFailed": "❌ Не вдалося завантажити задачі",
      "accountsLoadFailed": "❌ Не вдалося завантажити рахунки",
      "confirmed": "✅ Задачу підтверджено",
      "cancelled": "🛑 Задачу скасовано",
      "actionFailed": "Не вдалося оновити задачу",
      "created": "✅ Задачу створено",
      "createFailed": "Не вдалося створити задачу",
      "createModalTitle": "Додати ручне завдання",
      "createModalDescription": "Укажіть опис і суму, щоб поставити виплату в чергу для звірки.",
      "createSubmit": "Створити задачу",
      "updated": "✅ Задачу оновлено",
      "updateFailed": "Не вдалося оновити задачу",
      "editAction": "Редагувати",
      "editModalTitle": "Редагувати задачу перед підтвердженням",
      "editModalDescription": "Оновіть суму, дату, рахунок або категорію до того, як задача створить транзакцію.",
      "editSubmit": "Зберегти зміни",
      "sourceRequired": "Вкажіть опис",
      "sourcePlaceholder": "Опис",
      "categoryLabel": "Категорія",
      "categoryRequired": "Оберіть категорію",
      "categoryPlaceholder": "Оберіть найкращу категорію",
      "amountRequired": "Вкажіть суму",
      "accountRequired": "Рахунок обовʼязковий",
      "dueDateLabel": "Крайній термін",
      "dueDateRequired": "Вкажіть дату",
      "dueDatePlaceholder": "Оберіть дату",
      "legendTitle": "Легенда статусів",
      "legendTasks": "Типи задач",
      "legendTaskStates": "Стан задач",
      "scheduledFor": "Заплановано на {{date}}",
      "unscheduled": "Без дати",
      "upcomingHint": "Майбутня задача. Підтверджуйте її лише тоді, коли справді хочете провести цю виплату.",
      "scheduleState": {
        "overdue": "Прострочено",
        "today": "Сьогодні",
        "upcoming": "Майбутня",
        "unscheduled": "Без дати"
      },
      "createdAt": "Створено {{date}}",
      "confirmAction": "Підтвердити",
      "cancelAction": "Скасувати",
      "cancelConfirmTitle": "Скасувати цю задачу?",
      "cancelConfirmDescription": "Задачу буде видалено з черги. Ви зможете створити її знову за потреби.",
      "cancelConfirmOk": "Так, скасувати",
      "cancelConfirmCancel": "Залишити",
      "accountModalTitle": "Оберіть рахунок",
      "accountModalHint": "Ми підставимо останній використаний рахунок. Змініть його, якщо виплата має піти на інший рахунок.",
      "accountPlaceholder": "Рахунок",
      "untitled": "Без назви"
    }
  }
};

export default resources;
